var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash-container"},[_c('div',{staticClass:"splash-title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.messages),function(msg){return _c('div',{key:msg,staticClass:"splash-message"},[_vm._v(" "+_vm._s(msg)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }